export enum EventErrorType {
  NO_SYNCABLE_CALENDAR = 'NO_SYNCABLE_CALENDAR',
  NO_GROUP = 'NO_GROUP',
  UNKNOWN = 'UNKNOWN'
}

export class EventError extends Error {
  constructor(
    public type: EventErrorType,
    message: string
  ) {
    super(message)
    this.name = 'EventError'
    Object.setPrototypeOf(this, EventError.prototype)
  }
}
